
import { useState, useCallback } from 'react';
import Hero from './components/Hero';
import Services from './components/Services';
import WhyChooseUs from './components/WhyChooseUs';
import FeaturedProducts from './components/FeaturedProducts';
import StrongCTA from './components/StrongCTA';
import About from './components/About';
import Portfolio from './components/Portfolio';
import Equipment from './components/Equipment';
import Kits from './components/Kits';
import Classes from './components/Classes';
import Manuals from './components/Manuals';
import SignatureCocktails from './components/SignatureCocktails';
import SpecialPackages from './components/SpecialPackages';
import GlasswarePackages from './components/GlasswarePackages';
import LearnToMix from './components/LearnToMix';
import ConceptVideo from './components/ConceptVideo';
import VideoStoryboard from './components/VideoStoryboard';
import FeaturedVideos from './components/FeaturedVideos';
import VideoTestimonials from './components/VideoTestimonials';
import Testimonials from './components/Testimonials';
import FAQ from './components/FAQ';
import Booking from './components/Booking';
import Inquiry from './components/Inquiry';
import Footer from './components/Footer';
import Navbar from './components/Navbar';
import LogoIntro from '../../components/LogoIntro';

export default function HomePage() {
  const [showIntro, setShowIntro] = useState(true);
  const [pageVisible, setPageVisible] = useState(false);

  const handleIntroComplete = useCallback(() => {
    setShowIntro(false);
    setPageVisible(true);
  }, []);

  const handleLogoClick = useCallback(() => {
    setPageVisible(false);
    setShowIntro(true);
  }, []);

  return (
    <>
      {showIntro && <LogoIntro onComplete={handleIntroComplete} />}

      <div
        className="min-h-screen bg-white transition-opacity duration-700"
        style={{ opacity: pageVisible ? 1 : 0 }}
      >
        <Navbar scrolled={false} onLogoClick={handleLogoClick} />
        <Hero />
        <Services />
        <WhyChooseUs />
        <FeaturedProducts />
        <StrongCTA />
        <About />
        <Portfolio />
        <Equipment />
        <Kits />
        <Classes />
        <Manuals />
        <SignatureCocktails />
        <SpecialPackages />
        <GlasswarePackages />
        <LearnToMix />
        <ConceptVideo />
        <VideoStoryboard />
        <FeaturedVideos />
        <VideoTestimonials />
        <Testimonials />
        <FAQ />
        <Booking />
        <Inquiry />
        <Footer />
      </div>
    </>
  );
}
